// extracted by mini-css-extract-plugin
export default {"VodVideoPlayerContainer":"VodVideoPlayer_VodVideoPlayerContainer__3EcJ-"};